import _objectDestructuringEmpty from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectDestructuringEmpty.js";
import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
/* eslint-disable prettier/prettier */
import React from "react";
import { createTheme, ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import NavigateDownIcon from "../../../../../components/common/elsevier/Icons/NavigateDownIcon";
import styles from "./EngVillageTheme.module.scss";
var EVTheme = createTheme({
  // ! WE NEED TO MOVE THIS TO GLOBAL SCSS FILE INSTEAD OF USING createTheme MUI FUNCTIONALITY
  typography: {
    fontFamily: ["ElsevierSans", "Helvetica", "Arial", "sans-serif"].join(","),
    h1: {
      fontFamily: ["ElsevierDisplay-Light", "ElsevierDisplay", "ElsevierSans", "Arial", "Helvetica", "sans-serif"].join(","),
      fontWeight: 500
    },
    h2: {
      fontFamily: ["ElsevierDisplay-Light", "ElsevierDisplay", "ElsevierSans", "Arial", "Helvetica", "sans-serif"].join(","),
      fontWeight: 500
    },
    h3: {
      fontFamily: ["ElsevierDisplay-Light", "ElsevierDisplay", "ElsevierSans", "Arial", "Helvetica", "sans-serif"].join(","),
      fontWeight: 500
    },
    h4: {
      fontFamily: ["ElsevierDisplay-Light", "ElsevierDisplay", "ElsevierSans", "Arial", "Helvetica", "sans-serif"].join(","),
      fontWeight: 500
    },
    color: "#000000"
  },
  components: {
    MuiIconButton: {
      defaultProps: {
        disableRipple: true
      }
    },
    MuiAccordion: {
      defaultProps: {
        disableGutters: true
      }
    },
    MuiAccordionSummary: {
      defaultProps: {
        expandIcon: /*#__PURE__*/React.createElement(NavigateDownIcon, null)
      }
    },
    MuiCheckbox: {
      defaultProps: {
        disableRipple: true
      }
    }
  }
});
export var EngVillageThemeProvider = function EngVillageThemeProvider(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "".concat(styles.EngVillageTheme, " light-theme")
  }, props), /*#__PURE__*/React.createElement(StyledEngineProvider, {
    injectFirst: true
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: EVTheme
  }, props.children)));
};